var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoomInfo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_557_760)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 27.5,
    fill: "#FFEFD7",
    stroke: "#D5A151"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.194 17.1821V29.1138H25.7995V19.8335H36.4059C37.8122 19.8336 39.1606 20.3928 40.155 21.3872C41.1493 22.3816 41.7086 23.7299 41.7087 25.1362V37.0679H39.0573V33.0903H15.194V37.0679H12.5427V17.1821H15.194ZM20.4968 19.8335C21.5516 19.8335 22.5634 20.2527 23.3093 20.9985C24.0551 21.7444 24.4743 22.7563 24.4743 23.811C24.4742 24.8656 24.0549 25.8768 23.3093 26.6226C22.5634 27.3684 21.5516 27.7876 20.4968 27.7876C19.442 27.7875 18.4301 27.3684 17.6843 26.6226C16.9387 25.8768 16.5203 24.8655 16.5202 23.811C16.5202 22.7564 16.9386 21.7444 17.6843 20.9985C18.4301 20.2527 19.442 19.8335 20.4968 19.8335Z",
    fill: "url(#paint0_linear_557_760)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.194 17.1821V29.1138H25.7995V19.8335H36.4059C37.8122 19.8336 39.1606 20.3928 40.155 21.3872C41.1493 22.3816 41.7086 23.7299 41.7087 25.1362V37.0679H39.0573V33.0903H15.194V37.0679H12.5427V17.1821H15.194ZM20.4968 19.8335C21.5516 19.8335 22.5634 20.2527 23.3093 20.9985C24.0551 21.7444 24.4743 22.7563 24.4743 23.811C24.4742 24.8656 24.0549 25.8768 23.3093 26.6226C22.5634 27.3684 21.5516 27.7876 20.4968 27.7876C19.442 27.7875 18.4301 27.3684 17.6843 26.6226C16.9387 25.8768 16.5203 24.8655 16.5202 23.811C16.5202 22.7564 16.9386 21.7444 17.6843 20.9985C18.4301 20.2527 19.442 19.8335 20.4968 19.8335Z",
    stroke: "#DEA829"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_557_760",
    x1: 12.5427,
    y1: 27.125,
    x2: 41.7084,
    y2: 27.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEA829"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE8888"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_557_760"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomInfo);
export default __webpack_public_path__ + "static/media/room_info.f75463903f62a2aa06c65108a5bfed23.svg";
export { ForwardRef as ReactComponent };